import { Theme } from "@emotion/react"
import { Button, ButtonProps, SxProps } from "@mui/material"
import { useTranslation } from "react-i18next"

import { Direction } from "@/generated/TradingGateway"

import { INSTRUMENT_PAGE_LOCATORS } from "../../instruments"

interface TradeButtonProps extends ButtonProps {
  direction: Direction
  sx?: SxProps<Theme>
  to?: string
}

export const TradeButton = ({ direction, sx, ...props }: TradeButtonProps) => {
  const { t } = useTranslation()
  return (
    <Button
      data-testid={INSTRUMENT_PAGE_LOCATORS[direction]}
      sx={{
        flex: 1,
        borderRadius: 2,
        height: ({ spacing }) => spacing(6),
        "&:hover": {
          color: ({ palette }) =>
            palette.getContrastText(palette["bg-sell-primary"]),
        },
        backgroundColor: ({ palette }) =>
          direction === Direction.Buy
            ? palette["bg-buy-primary"]
            : palette["bg-sell-primary"],
        color: ({ palette }) =>
          palette.getContrastText(
            direction === Direction.Buy
              ? palette["bg-buy-primary"]
              : palette["bg-sell-primary"],
          ),
        ...sx,
      }}
      {...props}
    >
      {direction === Direction.Buy
        ? t("tradeButton.buy")
        : t("tradeButton.sell")}
    </Button>
  )
}
